import styled, { keyframes } from "styled-components";
import { Flex } from "Element/Flex";

export const ComingSoonWrapper = styled(Flex)`
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  margin: 16px;
`;

export const ComingSoonText = styled.h1`
  ${({ theme }) => theme.fontStyle.hero1}
  text-align: center;
  margin: inherit;
`;

const float = keyframes`
0% {
		/* box-shadow: 0 5px 15px 0px rgba(0,0,0,0.6); */
		transform: rotateY(180deg) translateY(0px);
	}
	50% {
		/* box-shadow: 0 25px 15px 0px rgba(0,0,0,0.2); */
		transform: rotateY(180deg) translateY(-20px);
	}
	100% {
		/* box-shadow: 0 5px 15px 0px rgba(0,0,0,0.6); */
		transform: rotateY(180deg) translateY(0px);
	}
`;

const floatRev = keyframes`
0% {
		/* box-shadow: 0 5px 15px 0px rgba(0,0,0,0.6); */
		transform:  translateY(-20px);
	}
	50% {
		/* box-shadow: 0 25px 15px 0px rgba(0,0,0,0.2); */
		transform:  translateY(0px);
	}
	100% {
		/* box-shadow: 0 5px 15px 0px rgba(0,0,0,0.6); */
		transform:  translateY(-20px);
	}
`;

export const UfoImg = styled.img`
  width: 96px;
  :first-child {
    animation: ${float} 3s ease-in-out infinite;
  }
  :last-child {
    animation: ${floatRev} 3s ease-in-out infinite reverse;
  }
`;
